import Icon from 'veui/components/Icon'
import { IconOneToOne } from 'dls-icons-vue'

Icon.register('one-to-one', IconOneToOne)
